/** Homepage section ids the primary nav can target. */
export const HOME_SECTIONS = ['about', 'projects', 'services', 'contact'];

/** Distance from viewport top used as the scroll-spy / scroll-to probe. */
export const NAV_PROBE_OFFSET = 96;

export const sectionDocumentTop = (el) =>
  el.getBoundingClientRect().top + window.scrollY;

export const getSectionScrollTop = (sectionId) => {
  const el = document.getElementById(sectionId);
  if (!el) return null;
  return Math.max(0, sectionDocumentTop(el) - (NAV_PROBE_OFFSET - 24));
};

/**
 * Scroll the window to a homepage section.
 * Use behavior: 'auto' under the wave wipe so the reveal opens on-target.
 */
export const scrollToHomeSection = (sectionId, { behavior = 'smooth' } = {}) => {
  const top = getSectionScrollTop(sectionId);
  if (top == null) return false;

  if (behavior === 'auto') {
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, top);
    document.documentElement.style.scrollBehavior = prev;
  } else {
    window.scrollTo({ top, behavior });
  }
  return true;
};

/** Read a pending homepage section from location state or hash. */
export const readPendingHomeSection = (location) => {
  const fromState = location?.state?.scrollTo;
  if (typeof fromState === 'string' && HOME_SECTIONS.includes(fromState)) {
    return fromState;
  }
  const fromHash = (location?.hash || '').replace(/^#/, '');
  if (HOME_SECTIONS.includes(fromHash)) {
    return fromHash;
  }
  return null;
};
